module.exports = __webpack_public_path__ + "img/avatar-default.37c3ea6b.png";